export default __webpack_public_path__ + "static/media/Damion-Regular.2e24147a.ttf";